import { Chess } from "@chesshotel/chess";
import { ChessTermType, TermAction, } from "@chesshotel/types";
export async function detectNegativeFollowsCheckmate(position, lastPosition) {
    const chess = new Chess(position.fen);
    const color = chess.turn();
    if (lastPosition.mateInMoves && !position.mateInMoves) {
        return {
            term: ChessTermType.FOLLOW_CHECKMATE,
            termAction: TermAction.MISS,
            movesUntilImpact: lastPosition.mateInMoves,
            translationKeys: {
                mateMoves: Math.abs(lastPosition.mateInMoves),
                color,
            },
            pvMoves: lastPosition.pvMoves,
            maxGain: 10,
        };
    }
    if (!lastPosition.mateInMoves && position.mateInMoves) {
        return {
            term: ChessTermType.FOLLOW_CHECKMATE,
            termAction: TermAction.ALLOW,
            movesUntilImpact: position.mateInMoves,
            translationKeys: {
                mateMoves: Math.abs(position.mateInMoves),
                color,
            },
            pvMoves: position.pvMoves,
            maxGain: 10,
        };
    }
    if (lastPosition.mateInMoves &&
        position.mateInMoves &&
        lastPosition.mateInMoves <= -position.mateInMoves) {
        return {
            term: ChessTermType.FOLLOW_CHECKMATE,
            termAction: TermAction.POSPONE,
            movesUntilImpact: position.mateInMoves,
            translationKeys: {
                mateMoves: Math.abs(position.mateInMoves),
                color,
            },
            pvMoves: lastPosition.pvMoves,
            maxGain: 10,
        };
    }
}
export function detectPositiveFollowsCheckmate(position, lastPosition) {
    const chess = new Chess(lastPosition.fen);
    const color = chess.turn();
    if (lastPosition.mateInMoves &&
        position.mateInMoves &&
        lastPosition.mateInMoves > -position.mateInMoves) {
        return {
            term: ChessTermType.FOLLOW_CHECKMATE,
            termAction: TermAction.PERFORM,
            movesUntilImpact: position.mateInMoves,
            translationKeys: {
                mateMoves: Math.abs(position.mateInMoves),
                color,
            },
            pvMoves: position.pvMoves,
            maxGain: 10,
        };
    }
}
//# sourceMappingURL=ending.js.map